import { Pageheader } from '@shared/Frontend/components/pageheader'
import { Clickable } from '@shared/Frontend/utils/clickable'
import i18next from 'i18next'
import React from 'react'
import { Updater } from 'widgets-for-react'
import { FormControls, FormSkeletonForm, FormUtils } from '../../../Shared/Frontend/forms'
import { getErrorMessage } from '../../../Shared/Frontend/validators/validatorExpr'
import { ContactUsState, contactUsUpdaters } from './contactUs.state'

export const ContactUsLayout = {
  ThankYou: () => (
    <div className="text-center">
      <h1>{i18next.t<string>('contactUs:feedbackThankYou')}</h1>
      <p>{i18next.t<string>('contactUs:feedbackThankYouMessage')}</p>
    </div>
  ),
  Wrapper: (html: JSX.Element) => (
    <section className="px-gutter">
      <div>{html}</div>
    </section>
  ),
  PageHeader: () => (
    <Pageheader
      title="Do you like our approach?"
      introduction="We are happy to get started with your digital growth. Challenge us!"
    />
  ),
  Form: (props: { setState: (_: Updater<ContactUsState>) => void; currentState: ContactUsState }): JSX.Element => (
    <FormSkeletonForm
      onSubmit={(e) => {
        e.preventDefault()
        props.setState(contactUsUpdaters.submit())
      }}
    >
      <FormControls.FormItemInGroup
        type="text"
        key="contactUsName"
        controlId="contactUsName"
        label={i18next.t<string>('contactUs:Name')}
        required={true}
        value={props.currentState.input.name || ''}
        onChange={(newValue) => props.setState(contactUsUpdaters.fields.name(newValue))}
        errorMessage={getErrorMessage(props.currentState.validatorResult.path('name'))}
        invalid={props.currentState.validatorResult.path('name').kind == 'failed'}
      />
      <FormControls.FormItemInGroup
        type="tel"
        inputMode="tel"
        key="contactUsPhoneNumber"
        controlId="formPhoneNumber"
        label={i18next.t<string>('contactUs:PhoneNumber')}
        required={true}
        value={props.currentState.input.phoneNumber || ''}
        onChange={(newValue) => props.setState(contactUsUpdaters.fields.phoneNumber(newValue))}
        invalid={props.currentState.validatorResult.path('phoneNumber').kind == 'failed'}
        errorMessage={getErrorMessage(props.currentState.validatorResult.path('phoneNumber'))}
      />
      <FormControls.FormItemInGroup
        type="email"
        inputMode="email"
        key="contactUsEmail"
        controlId="formBasicEmail"
        label={i18next.t<string>('contactUs:Email')}
        required={true}
        value={props.currentState.input.email || ''}
        onChange={(newValue) => props.setState(contactUsUpdaters.fields.email(newValue))}
        invalid={props.currentState.validatorResult.path('email').kind == 'failed'}
        errorMessage={getErrorMessage(props.currentState.validatorResult.path('email'))}
      />
      <FormControls.FormItemInGroup
        type="text"
        key="contactUsSubject"
        controlId="formSubject"
        label={i18next.t<string>('contactUs:Subject')}
        required={true}
        value={props.currentState.input.subject || ''}
        onChange={(newValue) => props.setState(contactUsUpdaters.fields.subject(newValue))}
        invalid={props.currentState.validatorResult.path('subject').kind == 'failed'}
        errorMessage={getErrorMessage(props.currentState.validatorResult.path('subject'))}
      />
      <FormControls.FormItemInGroup
        type="text"
        key="contactUsBody"
        controlId="formBody"
        label={i18next.t<string>('contactUs:Body')}
        required={true}
        as="textarea"
        rows={5}
        value={props.currentState.input.body || ''}
        onChange={(newValue) => props.setState(contactUsUpdaters.fields.body(newValue))}
        invalid={props.currentState.validatorResult.path('body').kind == 'failed'}
        errorMessage={getErrorMessage(props.currentState.validatorResult.path('body'))}
      />

      <div className="">
        <div className="">
          <Clickable
            elementKind="button"
            styleKind="button"
            type="submit"
            disabled={props.currentState.isValid() == false}
            onClick={() => {}}
            label={
              <FormUtils.SubmittingSpinnerOrText
                showLoader={props.currentState.submission != undefined}
                text="Submit"
              />
            }
          />
        </div>
      </div>
    </FormSkeletonForm>
  ),
}
